// store/package.js
import resource from '@/api/resource'

// Package name constants
export const PackageName = {
  // 'CP-QONTAKCHAT-2025-0001': 'CP-QONTAKCHAT-2025-0001', // Campaign Planner - Customs
  'CP-QONTAKCHAT-2025-0002': 'CP-QONTAKCHAT-2025-0002', // Customer Survey
  'CP-QONTAKCHAT-2025-0003': 'CP-QONTAKCHAT-2025-0003', // Room SLA (inbox) (dashboard no longer utilize this code)
  'CP-QONTAKCHAT-2025-0004': 'CP-QONTAKCHAT-2025-0004', // Inbox keseluruhan
  QONTAKCRM_KB_Chat_Integration: 'QONTAKCRM_KB_Chat_Integration', // Knowledge Base Chat Integration
  'CP-QONTAKCRM-2024-0006': 'CP-QONTAKCRM-2024-0006', // Manual ticket & deal (inbox)
  // 'CP-QONTAKCHAT-2025-0008': 'CP-QONTAKCHAT-2025-0008', // Email Broadcast
  'CP-QONTAKCHAT-2025-0013': 'CP-QONTAKCHAT-2025-0013', // Call
  'CP-QONTAKCHAT-2025-0014': 'CP-QONTAKCHAT-2025-0014', // Call
  'CP-QONTAKCHAT-2025-0015': 'CP-QONTAKCHAT-2025-0015', // Call
  'CP-QONTAKCHAT-2025-0020': 'CP-QONTAKCHAT-2025-0020', // Settings Customer Insight in Dashboard
  'QONTAKCHAT-SLA': 'QONTAKCHAT-SLA', // Settings SLA Management in Dashboard
  'CP-QONTAKCHAT-2026-0004': 'CP-QONTAKCHAT-2026-0004', // Desty Chat Integration
  'CP-QONTAKCHAT-2026-0005': 'CP-QONTAKCHAT-2026-0005', // WhatsApp Catalog / Commerce - Desty Integration
  'CP-QONTAKCHAT-2026-0032': 'CP-QONTAKCHAT-2026-0032', // Qontak Appointment Module
  // Add more packages as needed
}

// Helper function to transform package codes to map
const transformPackageCodesToMap = (codes) => {
  return codes.reduce((acc, code) => {
    acc[code] = true
    return acc
  }, {})
}

// State
export const state = () => ({
  isUsePackageCode: false,
  packageCodes: [],
  packageCodesMap: {},
  isLoading: false,
  isInitialized: false, // Track if API has been called
  qontakPackageName: '',
})

// Getters
export const getters = {
  isEnableBillingPackage: (state) => (packageCode) => {
    if (!state.isUsePackageCode) {
      return false
    }
    return !!state.packageCodesMap[packageCode]
  },
}

// Mutations
export const mutations = {
  SET_IS_LOADING(state, value) {
    state.isLoading = value
  },
  SET_PACKAGE_CONFIG(state, { isUsePackageCode, packageCodes }) {
    state.isUsePackageCode = isUsePackageCode
    state.packageCodes = packageCodes
    state.packageCodesMap = transformPackageCodesToMap(packageCodes)
    state.isInitialized = true // Mark as initialized when data is received
  },
  RESET_PACKAGE_STATE(state) {
    state.isUsePackageCode = false
    state.packageCodes = []
    state.packageCodesMap = {}
    state.isLoading = false
    state.isInitialized = false
  },
  SET_QONTAK_PACKAGE_NAME(state, packageName) {
    state.qontakPackageName = packageName
  },
}

// Actions
export const actions = {
  async fetchPackageConfig({ commit, state }) {
    // If already initialized, return immediately
    if (state.isInitialized) {
      return true
    }

    // If currently loading, wait a bit (simple debounce)
    if (state.isLoading) {
      return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
          if (!state.isLoading) {
            clearInterval(checkInterval)
            resolve(state.isInitialized)
          }
        }, 100)
      })
    }

    commit('SET_IS_LOADING', true)

    try {
      const { data } = await resource.get(
        '/api/core/v1/client_configs/organization_package'
      )

      const packages = {
        isUsePackageCode: data.data.is_use_package_code ?? false,
        packageCodes: data.data.package_code ?? [],
      }
      const isUnifiedApp = {
        isUnifiedApp: data.data.unified_app ?? false,
        unifiedAppVersion: data.data.unified_version ?? '',
      }

      commit('SET_PACKAGE_CONFIG', packages)
      commit('unified_app/SET_UNIFIED_APP_CONFIG', isUnifiedApp, {
        root: true,
      })
      commit(
        'SET_QONTAK_PACKAGE_NAME',
        data.data.main_package_name.qontak_chat ?? ''
      )
      return true
    } catch (err) {
      const errorMessage =
        (err._data && err._data.message) ||
        'An error occurred while fetching package config'

      // On error, still mark as initialized but with empty data
      commit('SET_PACKAGE_CONFIG', {
        isUsePackageCode: false,
        packageCodes: [],
      })

      // Don't throw, fail gracefully
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('Package config fetch failed:', errorMessage)
      }
      return false
    } finally {
      commit('SET_IS_LOADING', false)
    }
  },
}
